import { LoginSuccessQueryParameters } from "scmp-app/components/article/article-comments-drawer/consts";

export const SanitizedUrlKeys = [LoginSuccessQueryParameters];
